export const BreadcrumbsNavigationKeys = {
    quiz: 'Quiz',
    healthPlan: 'Health Plan',
    account: 'Account',
    checkout: 'Checkout'
};
